//
//
//
//
//
//
//
//
//
export default {
  mounted: function mounted() {
    console.log('this.$route', this.$route);
  }
};